import { AllData, Filtro, Variable_indicator } from "../../../interfaces/Indicator";
import { filterByCriteria } from "../../../utils/utils";
import { calculateValuesFromDataFormated, getDataForGraph } from "./helpers";

export const filterByCriteriaDualAxis = (
    criteria: { [key: string]: string[] },
    data: AllData[],
    pivotAxisYLeft: string,
    pivotAxisYRight: Variable_indicator,
    filters: Filtro[]
) => {
    if (!pivotAxisYRight) return filterByCriteria(criteria, data, filters, pivotAxisYLeft, null);

    const leftFilters: { [key: string]: string[] } = {};
    const rightFilters: { [key: string]: string[] } = {};

    const filtro = filters.find((f) => f.id === pivotAxisYRight.id);
    Object.entries(criteria).forEach(([key, values]) => {
        if (filtro && filtro.eje2) {
            rightFilters[key] = values;
        } else {
            leftFilters[key] = values;
        }
    });

    const hasLeftFilters = Object.keys(leftFilters).length > 0;
    const hasRightFilters = Object.keys(rightFilters).length > 0;

    const dataForGraph = getDataForGraph(data);

    const leftData = hasLeftFilters
        ? filterByCriteria(leftFilters, data, filters, pivotAxisYLeft, null)
        : filterByCriteria({}, data, filters, pivotAxisYLeft, null);

    const rightData = hasRightFilters
        ? filterByCriteria(rightFilters, data, filters, '', pivotAxisYRight)
        : calculateValuesFromDataFormated(dataForGraph, [pivotAxisYRight.titulo])

    const merged: { [year: string]: any } = {};

    const allYears = new Set([
        ...leftData.map((d) => d.name),
        ...rightData.map((d) => d.name),
    ]);

    allYears.forEach((year) => {
        const leftItem = leftData.find((d) => d.name === year);
        const rightItem = rightData.find((d) => d.name === year);

        merged[year] = {
            name: year,
            ...leftItem,
            ...rightItem,
        };
    });

    return Object.values(merged);
};